import { cn } from "@/utils/cn";
import { memo } from "react";

interface BackgroundImageProps {
  imageClassName?: string;
  backdrop?: boolean;
}

export const BackgroundImage = memo(function BackgroundImage({
  imageClassName,
  backdrop = true,
}: BackgroundImageProps) {
  return (
    <div
      className={cn(
        "fixed top-0 right-0 bottom-0 left-0 -z-10 h-full w-full bg-cover bg-center",
        imageClassName,
        {
          "after:absolute after:inset-0 after:z-0 after:block after:h-full after:w-full after:bg-gradient-to-b after:from-black/60 after:to-black/30":
            backdrop,
        },
      )}
    />
  );
});
